import { Checkbox, CheckboxProps, FormControlLabel, SxProps, Theme } from "@mui/material";

interface PCheckboxProps extends CheckboxProps {
  label?: string;
  formClassName?: string;
  sx?: SxProps<Theme>;
}

const PCheckbox = (props: PCheckboxProps) => {
  return (
    <FormControlLabel
      title={props.label || ""}
      sx={props.sx}
      label={props.label || ""}
      className={props.formClassName}
      control={<Checkbox size="small" color="secondary" {...props} />}
    />
  );
};

export default PCheckbox;
